import { HIDE_FAVORITES_ADDRESSES_DIV,  SHOW_FAVORITES_ADDRESSES_DIV} from "./displayFavoriteAndRecentAddressesReducer"

export const hideFavoritesAddressesDiv = () => ({
    type: HIDE_FAVORITES_ADDRESSES_DIV,
})

export const showFavoritesAddressesDiv = () => ({
    type: SHOW_FAVORITES_ADDRESSES_DIV,
})